import {
  Backdrop,
  CircularProgress
} from '@material-ui/core';

import { useStyles } from './backdrop.styles';

export const BackdropComponent = () => {

  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );

}